import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
  mlsProviderFranchise: null,
  mlsProviderFranchises: null,
  isNew: false,
  lastState: null,
  lastScope: null
};

const mlsProviderFranchiseReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.MLSPROVIDERFRANCHISE_START: {
      return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
    }
    case actionTypes.MLSPROVIDERFRANCHISE_SUCCESS: {
      return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
    }
    case actionTypes.MLSPROVIDERFRANCHISE_FAIL: {
      return updateState(state, { lastState: constants.STATE_FAIL });
    }
    default: {
      return state;
    }
  }
};

export default mlsProviderFranchiseReducer;